import React, { useState, useEffect, useRef } from "react";
import api from "../utils/axiosInstance";
import "bootstrap-icons/font/bootstrap-icons.css";

import { getApiBase } from "../utils/useApiBase";
const PHOTO_MAX_SIZE = 2 * 1024 * 1024;
const allowedPhotoTypes = new Set(["image/jpeg", "image/png"]);
const allowedPhotoExtensions = /\.(jpe?g|png)$/i;
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const getPhotoUrl = (filename) =>
  filename ? `${API_BASE}/uploads/photos/${filename}` : "";
const handleImgError = (e) => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); };

const AbashesheAkanguhe = ({ isUmudugudu = false }) => {
  const API_URL = isUmudugudu
    ? `${getApiBase()}/umudugudu/module-data/abasheshe`
    : `${getApiBase()}/abasheshe_akanguhe`;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGender, setFilterGender] = useState("all");
  const [filterHelp, setFilterHelp] = useState("all");
  const [filterAge, setFilterAge] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedCard, setExpandedCard] = useState(null);
  const perPage = 10;

  const [stats, setStats] = useState({
    total: 0, male: 0, female: 0, needHelp: 0,
    noNeedHelp: 0, avgAge: 0, elderly: 0, veryElderly: 0,
  });

  const initialForm = {
    amazina: "", imyaka: "", igitsina: "Gabo",
    nimero_ya_telephone: "", aderesi: "", ukeneye_ubufasha: "Oya", ifoto: "",
  };
  const [form, setForm] = useState(initialForm);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const calcStats = (arr) => {
    if (!arr?.length) {
      setStats({ total: 0, male: 0, female: 0, needHelp: 0, noNeedHelp: 0, avgAge: 0, elderly: 0, veryElderly: 0 });
      return;
    }
    const totalAge = arr.reduce((s, i) => s + Number(i.imyaka || 0), 0);
    setStats({
      total: arr.length,
      male: arr.filter(i => i.igitsina === "Gabo").length,
      female: arr.filter(i => i.igitsina === "Gore").length,
      needHelp: arr.filter(i => i.ukeneye_ubufasha === "Yego").length,
      noNeedHelp: arr.filter(i => i.ukeneye_ubufasha === "Oya").length,
      avgAge: (totalAge / arr.length).toFixed(1),
      elderly: arr.filter(i => { const a = Number(i.imyaka); return a >= 60 && a < 80; }).length,
      veryElderly: arr.filter(i => Number(i.imyaka) >= 80).length,
    });
  };

  const flash = (message, variant = "ok") => {
    setAlert({ message, variant });
    setTimeout(() => setAlert(null), 4500);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get(API_URL);
      const raw = res.data;
      const items = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);
      setData(items);
      setFilteredData(items);
      calcStats(items);
    } catch {
      flash("Habaye ikosa mu gusoma amakuru!", "err");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  useEffect(() => {
    let r = [...data];
    if (searchTerm.trim()) {
      const t = searchTerm.toLowerCase();
      r = r.filter(i =>
        i.amazina?.toLowerCase().includes(t) ||
        i.nimero_ya_telephone?.includes(t) ||
        i.aderesi?.toLowerCase().includes(t)
      );
    }
    if (filterGender !== "all") r = r.filter(i => i.igitsina === filterGender);
    if (filterHelp !== "all") r = r.filter(i => i.ukeneye_ubufasha === filterHelp);
    if (filterAge !== "all") {
      r = r.filter(i => {
        const a = Number(i.imyaka);
        if (filterAge === "60-79") return a >= 60 && a < 80;
        if (filterAge === "80+") return a >= 80;
        return true;
      });
    }
    setFilteredData(r);
    setCurrentPage(1);
  }, [searchTerm, filterGender, filterHelp, filterAge, data]);

  const lastIdx = currentPage * perPage;
  const firstIdx = lastIdx - perPage;
  const pageItems = filteredData.slice(firstIdx, lastIdx);
  const totalPages = Math.ceil(filteredData.length / perPage);

  const validate = () => {
    const e = {};
    if (!form.amazina?.trim()) e.amazina = "Amazina ni ngombwa";
    if (!form.imyaka || Number(form.imyaka) < 60) e.imyaka = "Imyaka nibura 60";
    if (form.nimero_ya_telephone && !/^07[2389]\d{7}$/.test(form.nimero_ya_telephone))
      e.nimero_ya_telephone = "Nimero ntago iri neza (078XXXXXXX)";
    setFormErrors(e);
    return !Object.keys(e).length;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
    if (formErrors[name]) setFormErrors(p => ({ ...p, [name]: "" }));
  };

  const resetForm = () => { setForm(initialForm); setSelectedFile(null); setFormErrors({}); setEditId(null); };

  const handleSave = async () => {
    if (!validate()) return flash("Uzuza neza amakuru!", "warn");
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (key !== "ifoto") formData.append(key, value ?? "");
      });
      if (selectedFile) formData.append("ifoto", selectedFile);

      if (editId) {
        await api.put(`${API_URL}/${editId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        flash("Amakuru yahinduwe neza!");
      } else {
        await api.post(API_URL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        flash("Uwo mu Izabukuru yashyizwemo neza!");
      }
      setShowModal(false);
      resetForm();
      loadData();
    } catch {
      flash("Ntibikunze kubika!", "err");
    }
  };

  const handleEdit = (item) => {
    setForm({
      amazina: item.amazina || "",
      imyaka: item.imyaka || "",
      igitsina: item.igitsina || "Gabo",
      nimero_ya_telephone: item.nimero_ya_telephone || "",
      aderesi: item.aderesi || "",
      ukeneye_ubufasha: item.ukeneye_ubufasha || "Oya",
      ifoto: item.ifoto || "",
    });
    setSelectedFile(null);
    setEditId(item.id);
    setFormErrors({});
    setShowModal(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setForm((prev) => ({ ...prev, ifoto: editId ? prev.ifoto : "" }));
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next.ifoto;
        return next;
      });
      return;
    }

    if (
      ((!allowedPhotoTypes.has(file.type) && file.type) ||
        !allowedPhotoExtensions.test(file.name || ""))
    ) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto igomba kuba JPG, JPEG cyangwa PNG",
      }));
      e.target.value = "";
      return;
    }

    if (file.size > PHOTO_MAX_SIZE) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto ntigomba kurenza 2MB",
      }));
      e.target.value = "";
      return;
    }

    setSelectedFile(file);
    setForm((prev) => ({ ...prev, ifoto: file.name }));
    setFormErrors((prev) => {
      const next = { ...prev };
      delete next.ifoto;
      return next;
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Uremeza ko ushaka gusiba?")) return;
    try {
      await api.delete(`${API_URL}/${id}`);
      flash("Yasibwe neza!");
      loadData();
    } catch {
      flash("Ntibikunze gusiba!", "err");
    }
  };

  const exportCSV = () => {
    const h = ["Amazina", "Imyaka", "Igitsina", "Telefoni", "Aderesi", "Ubufasha"];
    const rows = filteredData.map(i => [
      i.amazina, i.imyaka, i.igitsina,
      i.nimero_ya_telephone || "-", i.aderesi || "-", i.ukeneye_ubufasha
    ]);
    const csv = [h.join(","), ...rows.map(r => r.join(","))].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `abasheshe_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    flash("Excel yakoboye neza!");
  };

  const getAgeTag = (age) => {
    const a = Number(age);
    if (a >= 80) return "el-tag-red";
    if (a >= 70) return "el-tag-amber";
    return "el-tag-cyan";
  };

  const DropFilter = ({ icon, label, value, options, onChange }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const active = value !== "all";

    useEffect(() => {
      if (!open) return;
      const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
      document.addEventListener("mousedown", close);
      document.addEventListener("touchstart", close);
      return () => { document.removeEventListener("mousedown", close); document.removeEventListener("touchstart", close); };
    }, [open]);

    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button className={`el-filter-btn${active ? " active" : ""}`} onClick={() => setOpen(!open)}>
          <i className={`bi bi-${icon}`}></i>
          <span>{active ? options.find(o => o.v === value)?.l || label : label}</span>
          <i className={`bi bi-chevron-${open ? "up" : "down"}`} style={{ marginLeft: "auto", fontSize: "0.62rem", opacity: 0.45 }}></i>
        </button>
        {open && (
          <div className="el-dropdown">
            {options.map(o => (
              <button key={o.v} className={`el-drop-item${value === o.v ? " sel" : ""}`}
                onClick={() => { onChange(o.v); setOpen(false); }}>
                {value === o.v && <i className="bi bi-check2" style={{ color: "#0B3D91" }}></i>}
                {o.l}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const pages = [];
    const s = Math.max(1, currentPage - 2);
    const e = Math.min(totalPages, currentPage + 2);
    for (let i = s; i <= e; i++) pages.push(i);

    return (
      <div className="el-pagination">
        <span className="el-pg-info">
          {firstIdx + 1}–{Math.min(lastIdx, filteredData.length)} kuri {filteredData.length}
        </span>
        <div className="el-pg-btns">
          <button className="el-pg-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(1)}>
            <i className="bi bi-chevron-double-left"></i>
          </button>
          <button className="el-pg-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          {pages.map(p => (
            <button key={p} className={`el-pg-btn${p === currentPage ? " active" : ""}`} onClick={() => setCurrentPage(p)}>{p}</button>
          ))}
          <button className="el-pg-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <button className="el-pg-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)}>
            <i className="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        .el-root *, .el-root *::before, .el-root *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          -webkit-tap-highlight-color: transparent;
        }
        .el-root { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
        .el-root ::-webkit-scrollbar { width: 5px; height: 5px; }
        .el-root ::-webkit-scrollbar-track { background: transparent; }
        .el-root ::-webkit-scrollbar-thumb { background: rgba(11,61,145,0.2); border-radius: 10px; }

        @keyframes elUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        @keyframes elScale { from { opacity:0; transform:scale(0.94); } to { opacity:1; transform:scale(1); } }
        @keyframes elSlide { from { opacity:0; transform:translateX(-12px); } to { opacity:1; transform:translateX(0); } }
        @keyframes elPop {
          0% { opacity:0; transform:translateY(-10px) scale(0.94); }
          60% { transform:translateY(2px) scale(1.01); }
          100% { opacity:1; transform:translateY(0) scale(1); }
        }
        @keyframes elGrad { 0%,100% { background-position:0% 50%; } 50% { background-position:100% 50%; } }
        @keyframes elPulse { 0%,100% { box-shadow:0 0 0 0 rgba(11,61,145,0); } 50% { box-shadow:0 0 0 7px rgba(11,61,145,0.05); } }
        @keyframes elDot { 0%,80%,100% { transform:scale(0); } 40% { transform:scale(1); } }
        @keyframes elFloat { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-5px); } }
        @keyframes elCount { from { opacity:0; transform:translateY(5px); } to { opacity:1; transform:translateY(0); } }

        .el-shell {
          min-height: 100vh;
          min-height: 100dvh;
          background: #ffffff;
          color: #0d1b2a;
          position: relative;
          overflow-x: hidden;
        }
        .el-shell::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 40% at 10% 8%, rgba(11,61,145,0.06) 0%, transparent 50%),
            radial-gradient(ellipse 45% 55% at 90% 90%, rgba(220,38,38,0.04) 0%, transparent 45%),
            radial-gradient(ellipse 30% 30% at 50% 50%, rgba(11,61,145,0.025) 0%, transparent 38%);
          pointer-events: none;
          z-index: 0;
        }
        .el-layer { position: relative; z-index: 1; }
        .el-wrap { max-width: 1420px; margin: 0 auto; padding: 20px 16px 44px; }

        /* HEADER */
        .el-header { text-align: center; margin-bottom: 26px; animation: elUp 0.5s ease; }
        .el-chip {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 5px 14px; border-radius: 10px;
          background: rgba(11,61,145,0.08); border: 1px solid rgba(11,61,145,0.16);
          color: #0B3D91; font-size: 0.66rem; font-weight: 700;
          letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 12px;
        }
        .el-title {
          font-size: clamp(1.4rem, 5vw, 2.5rem); font-weight: 900; line-height: 1.08; margin-bottom: 6px;
          background: linear-gradient(135deg, #0B3D91, #0B3D91, #0B3D91, #0B3D91);
          background-size: 300% 300%; animation: elGrad 7s ease infinite;
          -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
        }
        .el-sub { color: rgba(11,61,145,0.55); font-size: clamp(0.82rem, 2vw, 0.95rem); max-width: 460px; margin: 0 auto; }

        /* ACTIONS */
        .el-actions { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; margin-bottom: 22px; animation: elUp 0.55s ease; }
        .el-btn {
          padding: 10px 20px; border-radius: 12px; font-weight: 650; font-size: 0.84rem;
          font-family: inherit; cursor: pointer; transition: all 0.3s; display: inline-flex;
          align-items: center; gap: 7px; border: none; white-space: nowrap;
          position: relative; overflow: hidden;
        }
        .el-btn::after {
          content: ''; position: absolute; top: 50%; left: 50%;
          width: 0; height: 0; background: rgba(11,61,145,0.07);
          border-radius: 50%; transform: translate(-50%,-50%);
          transition: width 0.5s, height 0.5s;
        }
        .el-btn:active::after { width: 300px; height: 300px; }
        .el-btn-primary {
          background: linear-gradient(135deg, #0B3D91, #0B3D91); color: #ffffff;
          box-shadow: 0 3px 14px rgba(11,61,145,0.22);
        }
        .el-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(11,61,145,0.38); }
        .el-btn-ghost {
          background: transparent; color: rgba(11,61,145,0.7);
          border: 1.5px solid rgba(11,61,145,0.07);
        }
        .el-btn-ghost:hover { color: #0d1b2a; border-color: rgba(11,61,145,0.18); background: rgba(11,61,145,0.025); }
        .el-btn-green {
          background: rgba(22,163,74,0.1); color: #16a34a;
          border: 1.5px solid rgba(22,163,74,0.18);
        }
        .el-btn-green:hover { background: rgba(22,163,74,0.16); box-shadow: 0 4px 14px rgba(22,163,74,0.12); }

        /* ALERT */
        .el-alert {
          padding: 12px 16px; border-radius: 14px; display: flex; align-items: center;
          gap: 10px; font-weight: 500; font-size: 0.84rem; margin-bottom: 18px;
          animation: elPop 0.4s cubic-bezier(0.34,1.56,0.64,1); border: 1px solid;
        }
        .el-alert-ok { background: rgba(22,163,74,0.06); border-color: rgba(22,163,74,0.15); color: #16a34a; }
        .el-alert-err { background: rgba(220,38,38,0.06); border-color: rgba(220,38,38,0.15); color: #dc2626; }
        .el-alert-warn { background: rgba(217,119,6,0.06); border-color: rgba(217,119,6,0.15); color: #d97706; }
        .el-alert-info { background: rgba(11,61,145,0.06); border-color: rgba(11,61,145,0.15); color: #0369a1; }
        .el-alert-icon {
          width: 32px; height: 32px; min-width: 32px; border-radius: 9px;
          display: flex; align-items: center; justify-content: center; font-size: 0.9rem;
        }
        .el-alert-x {
          margin-left: auto; background: none; border: none; color: inherit;
          cursor: pointer; padding: 3px; opacity: 0.5; font-size: 0.85rem; transition: opacity 0.2s;
        }
        .el-alert-x:hover { opacity: 1; }

        /* STATS */
        .el-stats-main {
          display: grid; grid-template-columns: repeat(4, 1fr);
          gap: 10px; margin-bottom: 10px; animation: elUp 0.6s ease;
        }
        .el-stats-age {
          display: grid; grid-template-columns: repeat(2, 1fr);
          gap: 10px; margin-bottom: 22px; animation: elUp 0.65s ease;
        }
        .el-stat {
          background: linear-gradient(150deg, rgba(240,244,251,0.9), rgba(255,255,255,0.96));
          backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(11,61,145,0.04); border-radius: 16px;
          padding: 18px 10px; text-align: center;
          transition: all 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
          position: relative; overflow: hidden; cursor: default;
        }
        .el-stat::after {
          content: ''; position: absolute; top: 0; left: 0; right: 0;
          height: 2.5px; border-radius: 16px 16px 0 0; opacity: 0; transition: opacity 0.35s;
        }
        .el-stat:hover { transform: translateY(-4px); border-color: rgba(11,61,145,0.07); }
        .el-stat:hover::after { opacity: 1; }
        .el-stat.purple::after { background: linear-gradient(90deg, #0B3D91, #0B3D91); }
        .el-stat.purple:hover { box-shadow: 0 12px 36px rgba(11,61,145,0.1); }
        .el-stat.red::after { background: linear-gradient(90deg, #dc2626, #dc2626); }
        .el-stat.red:hover { box-shadow: 0 12px 36px rgba(220,38,38,0.08); }
        .el-stat.green::after { background: linear-gradient(90deg, #16a34a, #16a34a); }
        .el-stat.green:hover { box-shadow: 0 12px 36px rgba(22,163,74,0.08); }
        .el-stat.blue::after { background: linear-gradient(90deg, #0B3D91, #0369a1); }
        .el-stat.blue:hover { box-shadow: 0 12px 36px rgba(11,61,145,0.08); }
        .el-stat.amber::after { background: linear-gradient(90deg, #d97706, #d97706); }
        .el-stat.amber:hover { box-shadow: 0 12px 36px rgba(217,119,6,0.08); }
        .el-stat.rose::after { background: linear-gradient(90deg, #dc2626, #dc2626); }
        .el-stat.rose:hover { box-shadow: 0 12px 36px rgba(220,38,38,0.08); }

        .el-stat-icon {
          width: 40px; height: 40px; border-radius: 12px;
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.05rem; margin-bottom: 8px; transition: transform 0.35s;
        }
        .el-stat:hover .el-stat-icon { transform: scale(1.12) rotate(-4deg); }
        .el-stat-val {
          font-size: clamp(1.3rem, 2.8vw, 1.9rem); font-weight: 800; color: #0d1b2a;
          line-height: 1; margin-bottom: 3px; letter-spacing: -0.03em; animation: elCount 0.5s ease;
        }
        .el-stat-lbl {
          font-size: 0.58rem; color: rgba(11,61,145,0.65); font-weight: 600;
          text-transform: uppercase; letter-spacing: 0.08em;
        }
        .el-stat-sub { font-size: 0.6rem; color: rgba(11,61,145,0.55); margin-top: 3px; }
        .el-progress { height: 3px; border-radius: 2px; background: rgba(11,61,145,0.03); margin-top: 8px; overflow: hidden; }
        .el-progress-bar { height: 100%; border-radius: 2px; transition: width 0.8s ease; }

        /* GLASS */
        .el-glass {
          background: linear-gradient(145deg, rgba(240,244,251,0.88), rgba(255,255,255,0.96));
          backdrop-filter: blur(20px) saturate(1.2); -webkit-backdrop-filter: blur(20px) saturate(1.2);
          border: 1px solid rgba(11,61,145,0.045); border-radius: 18px;
          transition: border-color 0.4s, box-shadow 0.4s; overflow: hidden;
        }
        .el-glass:hover { border-color: rgba(11,61,145,0.08); box-shadow: 0 4px 24px rgba(15,23,42,0.18); }
        .el-glass-body { padding: clamp(16px, 3.5vw, 36px); }

        /* FILTERS */
        .el-filters {
          display: grid; grid-template-columns: 2fr repeat(3, 1fr);
          gap: 8px; margin-bottom: 20px; animation: elUp 0.7s ease;
        }
        .el-search-wrap { position: relative; }
        .el-search-icon {
          position: absolute; left: 13px; top: 50%; transform: translateY(-50%);
          color: rgba(11,61,145,0.45); font-size: 0.9rem; transition: color 0.3s;
          z-index: 2; pointer-events: none;
        }
        .el-search-wrap:focus-within .el-search-icon { color: #0B3D91; }
        .el-search {
          width: 100%; padding: 11px 15px 11px 40px;
          background: rgba(240,244,251,0.5); border: 1.5px solid rgba(11,61,145,0.05);
          border-radius: 12px; color: #0d1b2a; font-size: 0.86rem; font-weight: 500;
          outline: none; transition: all 0.3s; font-family: inherit;
        }
        .el-search::placeholder { color: rgba(11,61,145,0.4); }
        .el-search:focus {
          border-color: #0B3D91; box-shadow: 0 0 0 3px rgba(11,61,145,0.08);
          background: rgba(240,244,251,0.75);
        }
        .el-filter-btn {
          width: 100%; padding: 11px 12px; background: rgba(240,244,251,0.5);
          border: 1.5px solid rgba(11,61,145,0.045); border-radius: 12px;
          color: rgba(11,61,145,0.65); font-size: 0.8rem; font-weight: 600;
          cursor: pointer; transition: all 0.3s; display: flex; align-items: center;
          gap: 6px; white-space: nowrap; font-family: inherit;
        }
        .el-filter-btn:hover { border-color: rgba(11,61,145,0.1); color: rgba(11,61,145,0.8); }
        .el-filter-btn.active { border-color: rgba(11,61,145,0.25); color: #0B3D91; background: rgba(11,61,145,0.05); }
        .el-dropdown {
          position: absolute; top: calc(100% + 5px); left: 0; right: 0;
          background: rgba(240,244,251,0.97); backdrop-filter: blur(14px);
          border: 1px solid rgba(11,61,145,0.07); border-radius: 12px;
          box-shadow: 0 10px 36px rgba(15,23,42,0.5); z-index: 50;
          overflow: hidden; animation: elScale 0.18s ease;
        }
        .el-drop-item {
          padding: 9px 13px; font-size: 0.8rem; color: rgba(11,61,145,0.65);
          cursor: pointer; transition: all 0.2s; display: flex; align-items: center;
          gap: 7px; border: none; background: none; width: 100%; text-align: left; font-family: inherit;
        }
        .el-drop-item:hover { background: rgba(11,61,145,0.06); color: #0d1b2a; }
        .el-drop-item.sel { color: #0B3D91; background: rgba(11,61,145,0.04); }

        /* TABLE */
        .el-table-wrap { border-radius: 13px; overflow: hidden; border: 1px solid rgba(11,61,145,0.03); position: relative; }
        .el-table-scroll {
          max-height: 480px;
          max-width: 100%;
          overflow: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }
        .el-tbl { width: max(100%, 920px); border-collapse: separate; border-spacing: 0; }
        .el-tbl thead { position: sticky; top: 0; z-index: 5; }
        .el-tbl th {
          padding: 12px 15px; font-size: 0.62rem; font-weight: 700;
          text-transform: uppercase; letter-spacing: 0.1em;
          color: rgba(255,255,255,0.85); border-bottom: 1px solid rgba(11,61,145,0.04);
          background: rgba(11,61,145,0.96); backdrop-filter: blur(8px); white-space: nowrap; text-align: left;
        }
        .el-tbl td {
          padding: 12px 15px; font-size: 0.82rem; color: rgba(11,61,145,0.85);
          border-bottom: 1px solid rgba(11,61,145,0.02); vertical-align: middle;
        }
        .el-tbl tbody tr { transition: all 0.2s; cursor: default; }
        .el-tbl tbody tr:hover { background: rgba(11,61,145,0.035); }
        .el-tbl tbody tr:last-child td { border-bottom: none; }

        .el-tag {
          display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 7px;
          font-size: 0.68rem; font-weight: 650; letter-spacing: 0.015em;
          border: 1px solid transparent; white-space: nowrap;
        }
        .el-tag-purple { background: rgba(11,61,145,0.1); color: #0B3D91; border-color: rgba(11,61,145,0.18); }
        .el-tag-blue { background: rgba(11,61,145,0.1); color: #0369a1; border-color: rgba(11,61,145,0.18); }
        .el-tag-green { background: rgba(22,163,74,0.1); color: #16a34a; border-color: rgba(22,163,74,0.18); }
        .el-tag-red { background: rgba(220,38,38,0.08); color: #dc2626; border-color: rgba(220,38,38,0.15); }
        .el-tag-amber { background: rgba(217,119,6,0.1); color: #d97706; border-color: rgba(217,119,6,0.18); }
        .el-tag-cyan { background: rgba(3,105,161,0.1); color: #0369a1; border-color: rgba(3,105,161,0.18); }
        .el-tag-rose { background: rgba(220,38,38,0.08); color: #dc2626; border-color: rgba(220,38,38,0.15); }

        /* ACTIONS */
        .el-act-grp { display: flex; gap: 5px; justify-content: center; }
        .el-act {
          width: 34px; height: 34px; border-radius: 8px; border: 1.5px solid;
          background: transparent; display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.25s; font-size: 0.78rem;
        }
        .el-act:hover { transform: translateY(-2px); }
        .el-act.view { border-color: rgba(3,105,161,0.22); color: #0369a1; }
        .el-act.view:hover { background: rgba(3,105,161,0.08); box-shadow: 0 3px 10px rgba(3,105,161,0.16); }
        .el-act.edit { border-color: rgba(11,61,145,0.22); color: #0B3D91; }
        .el-act.edit:hover { background: rgba(11,61,145,0.08); box-shadow: 0 3px 10px rgba(11,61,145,0.16); }
        .el-act.del { border-color: rgba(220,38,38,0.22); color: #dc2626; }
        .el-act.del:hover { background: rgba(220,38,38,0.08); box-shadow: 0 3px 10px rgba(220,38,38,0.16); }

        /* MOBILE CARDS */
        .el-cards { display: none; }
        .el-card {
          background: rgba(240,244,251,0.5); border: 1px solid rgba(11,61,145,0.035);
          border-radius: 14px; padding: 14px; margin-bottom: 8px;
          transition: all 0.3s; animation: elUp 0.3s ease both;
        }
        .el-card:active { background: rgba(11,61,145,0.03); border-color: rgba(11,61,145,0.1); }
        .el-card-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }
        .el-card-name { font-weight: 700; color: #0d1b2a; font-size: 0.92rem; margin-bottom: 4px; }
        .el-card-tags { display: flex; gap: 5px; flex-wrap: wrap; }
        .el-card-row {
          display: flex; justify-content: space-between; padding: 5px 0;
          border-bottom: 1px solid rgba(11,61,145,0.02); font-size: 0.78rem;
        }
        .el-card-row:last-child { border-bottom: none; }
        .el-card-lbl { color: rgba(11,61,145,0.55); font-weight: 500; }
        .el-card-val {
          color: rgba(11,61,145,0.85);
          font-weight: 600;
          text-align: right;
          max-width: 62%;
          overflow-wrap: anywhere;
        }
        .el-card-actions {
          display: flex; gap: 6px; justify-content: flex-end; margin-top: 10px;
          padding-top: 8px; border-top: 1px solid rgba(11,61,145,0.025);
        }
        .el-card-expand { text-align: center; padding: 6px; color: rgba(11,61,145,0.3); font-size: 0.7rem; cursor: pointer; }

        /* PAGINATION */
        .el-pagination {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 10px; margin-top: 16px; padding-top: 14px;
          border-top: 1px solid rgba(11,61,145,0.035);
        }
        .el-pg-info { font-size: 0.74rem; color: rgba(11,61,145,0.55); }
        .el-pg-btns { display: flex; gap: 3px; flex-wrap: wrap; justify-content: flex-end; }
        .el-pg-btn {
          width: 36px; height: 36px; border-radius: 10px;
          border: 1px solid rgba(11,61,145,0.05); background: transparent;
          color: rgba(11,61,145,0.6); font-size: 0.75rem; font-weight: 600;
          cursor: pointer; transition: all 0.2s; display: flex;
          align-items: center; justify-content: center; font-family: inherit;
        }
        .el-pg-btn:hover:not(:disabled) { border-color: rgba(11,61,145,0.25); color: #0B3D91; background: rgba(11,61,145,0.05); }
        .el-pg-btn.active {
          background: linear-gradient(135deg, #0B3D91, #0B3D91); border-color: transparent;
          color: #ffffff; box-shadow: 0 2px 8px rgba(11,61,145,0.25);
        }
        .el-pg-btn:disabled { opacity: 0.25; cursor: not-allowed; }

        /* MODAL */
        .el-overlay {
          position: fixed; inset: 0; background: rgba(15,23,42,0.72);
          backdrop-filter: blur(6px); z-index: 1000; display: flex;
          align-items: center; justify-content: center; padding: 14px; animation: elUp 0.2s ease;
        }
        .el-modal {
          background: linear-gradient(155deg, rgba(240,244,251,0.98), rgba(255,255,255,0.99));
          border: 1px solid rgba(11,61,145,0.06); border-radius: 20px;
          width: 100%; max-width: 660px; max-height: 88vh; overflow-y: auto;
          animation: elScale 0.3s ease;
          box-shadow: 0 20px 70px rgba(15,23,42,0.55), 0 0 80px rgba(11,61,145,0.05);
        }
        .el-modal-head {
          padding: 18px 22px; border-bottom: 1px solid rgba(11,61,145,0.04);
          display: flex; align-items: center; justify-content: space-between;
          position: sticky; top: 0; background: rgba(240,244,251,0.98);
          backdrop-filter: blur(10px); z-index: 5; border-radius: 20px 20px 0 0;
        }
        .el-modal-title { font-size: 1.1rem; font-weight: 800; color: #0d1b2a; display: flex; align-items: center; gap: 9px; }
        .el-modal-x {
          width: 34px; height: 34px; border-radius: 10px;
          border: 1px solid rgba(11,61,145,0.07); background: rgba(11,61,145,0.02);
          color: rgba(11,61,145,0.6); cursor: pointer; display: flex;
          align-items: center; justify-content: center; transition: all 0.2s; font-size: 0.95rem;
        }
        .el-modal-x:hover { color: #0d1b2a; border-color: rgba(11,61,145,0.18); background: rgba(11,61,145,0.05); }
        .el-modal-body { padding: 22px; }
        .el-modal-foot {
          padding: 14px 22px; border-top: 1px solid rgba(11,61,145,0.04);
          display: flex; gap: 8px; justify-content: flex-end;
        }

        /* FORM */
        .el-form-grid { display: grid; gap: 14px; grid-template-columns: repeat(2, 1fr); }
        .el-form-full { grid-column: 1 / -1; }
        .el-field { position: relative; }
        .el-label {
          display: block; font-size: 0.68rem; font-weight: 650;
          color: rgba(11,61,145,0.6); margin-bottom: 6px;
          text-transform: uppercase; letter-spacing: 0.06em; transition: color 0.3s;
        }
        .el-field:focus-within .el-label { color: #0B3D91; }
        .el-req { color: #dc2626; margin-left: 2px; }
        .el-inp-wrap { position: relative; }
        .el-inp-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: rgba(11,61,145,0.4); font-size: 0.88rem; transition: color 0.3s;
          z-index: 2; pointer-events: none;
        }
        .el-field:focus-within .el-inp-icon { color: #0B3D91; }
        .el-inp {
          width: 100%; padding: 11px 12px 11px 38px;
          background: rgba(240,244,251,0.5); border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px; min-height: 46px; color: #0d1b2a; font-size: 0.88rem; font-weight: 500;
          outline: none; transition: all 0.3s; font-family: inherit;
          -webkit-appearance: none; appearance: none;
        }
        .el-inp::placeholder { color: rgba(11,61,145,0.38); }
        .el-inp:focus { border-color: #0B3D91; background: rgba(240,244,251,0.75); box-shadow: 0 0 0 3px rgba(11,61,145,0.08); }
        .el-inp.err { border-color: #dc2626; }
        .el-inp.err:focus { box-shadow: 0 0 0 3px rgba(220,38,38,0.1); }
        .el-sel {
          width: 100%; padding: 11px 34px 11px 38px;
          background: rgba(240,244,251,0.5); border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px; min-height: 46px; color: #0d1b2a; font-size: 0.88rem; font-weight: 500;
          outline: none; transition: all 0.3s; cursor: pointer; font-family: inherit;
          -webkit-appearance: none; appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='rgba(11,61,145,0.28)' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right 12px center;
        }
        .el-sel:focus { border-color: #0B3D91; box-shadow: 0 0 0 3px rgba(11,61,145,0.08); }
        .el-inp[type="file"] {
          padding: 10px 12px;
          min-height: 50px;
        }
        .el-inp[type="file"]::file-selector-button {
          margin-right: 10px;
          border: 0;
          border-radius: 9px;
          padding: 9px 12px;
          font: inherit;
          font-weight: 700;
          background: rgba(11,61,145,0.16);
          color: #0d1b2a;
          cursor: pointer;
        }
        .el-sel option { background: #ffffff; color: #0d1b2a; }
        .el-err-msg { font-size: 0.68rem; color: #dc2626; margin-top: 3px; font-weight: 500; }

        /* DETAIL */
        .el-detail-avatar {
          width: 60px; height: 60px; border-radius: 16px;
          background: linear-gradient(135deg, rgba(11,61,145,0.12), rgba(11,61,145,0.12));
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.5rem; color: #0B3D91; margin-bottom: 10px;
        }
        .el-detail-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .el-detail-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
        .el-detail-item {
          padding: 12px; background: rgba(240,244,251,0.45);
          border: 1px solid rgba(11,61,145,0.03); border-radius: 11px;
        }
        .el-detail-lbl {
          font-size: 0.64rem; font-weight: 700; color: rgba(11,61,145,0.55);
          text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px;
        }
        .el-detail-val { font-size: 0.9rem; font-weight: 600; color: #0d1b2a; }

        /* EMPTY / LOADER */
        .el-empty { text-align: center; padding: 44px 16px; }
        .el-empty-icon {
          width: 64px; height: 64px; border-radius: 18px;
          background: rgba(11,61,145,0.05); border: 1px solid rgba(11,61,145,0.08);
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.5rem; color: rgba(11,61,145,0.45); margin-bottom: 14px;
          animation: elFloat 3s ease-in-out infinite;
        }
        .el-loader { display: flex; gap: 5px; justify-content: center; padding: 44px; }
        .el-loader span {
          width: 9px; height: 9px; border-radius: 50%; background: #0B3D91;
          animation: elDot 1.4s infinite ease-in-out both;
        }
        .el-loader span:nth-child(1) { animation-delay: -0.32s; }
        .el-loader span:nth-child(2) { animation-delay: -0.16s; }

        .el-footer {
          text-align: center; margin-top: 32px; padding-bottom: 14px;
          color: rgba(11,61,145,0.4); font-size: 0.7rem; font-weight: 500;
        }

        /* RESPONSIVE */
        @media (max-width: 1024px) {
          .el-stats-main { grid-template-columns: repeat(2, 1fr); }
          .el-filters { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 767px) {
          .el-wrap { padding: 12px 10px 28px; }
          .el-desktop-tbl { display: none !important; }
          .el-cards { display: block !important; }
          .el-filters { grid-template-columns: 1fr; }
          .el-form-grid { grid-template-columns: 1fr; }
          .el-detail-grid { grid-template-columns: 1fr; }
          .el-modal { border-radius: 16px; max-height: 85vh; }
          .el-modal-body { padding: 16px; }
          .el-actions { justify-content: stretch; }
          .el-actions .el-btn { flex: 1; justify-content: center; }
          .el-modal-foot { flex-direction: column; }
          .el-modal-foot .el-btn { width: 100%; justify-content: center; }
          .el-pagination { flex-direction: column; align-items: center; }
        }
        @media (max-width: 576px) {
          .el-stat { padding: 14px 8px; border-radius: 12px; }
          .el-stat-icon { width: 34px; height: 34px; font-size: 0.9rem; border-radius: 10px; margin-bottom: 6px; }
          .el-stat-val { font-size: 1.15rem; }
          .el-stat-lbl { font-size: 0.52rem; }
          .el-stats-main, .el-stats-age { gap: 7px; }
          .el-glass { border-radius: 14px; }
          .el-glass-body { padding: 12px; }
          .el-inp, .el-sel, .el-search { font-size: 0.84rem; padding-top: 10px; padding-bottom: 10px; border-radius: 10px; }
          .el-btn { padding: 9px 14px; font-size: 0.78rem; border-radius: 10px; }
          .el-act { width: 38px; height: 38px; }
          .el-pg-btns { justify-content: center; }
          .el-card-actions { flex-wrap: wrap; }
          .el-detail-avatar { width: min(100%, 180px) !important; height: 180px !important; border-radius: 20px !important; }
        }
        @media (max-width: 400px) {
          .el-stats-main { grid-template-columns: repeat(2, 1fr); gap: 5px; }
          .el-stats-age { gap: 5px; }
          .el-stat-val { font-size: 1rem; }
        }
        @supports (-webkit-touch-callout: none) {
          .el-shell { min-height: 100dvh; }
          .el-inp, .el-sel, .el-search { font-size: 16px; }
        }
        @media (hover: none) and (pointer: coarse) {
          .el-stat:hover { transform: none; box-shadow: none; }
          .el-act:hover { transform: none; }
        }
      `}</style>

      <div className="el-root">
        <div className="el-shell">
          <div className="el-layer">
            <div className="el-wrap">

              {/* Header */}
              <div className="el-header">
                <div className="el-chip">
                  <i className="bi bi-heart-pulse-fill"></i>
                  Gucunga Abageze mu Izabukuru
                </div>
                <h1 className="el-title">Abageze mu Izabukuru</h1>
                <p className="el-sub">Gucunga no kugenzura amakuru y'abageze mu izabukuru bo mu mudugudu</p>
              </div>

              {/* Actions */}
              <div className="el-actions">
                <button className="el-btn el-btn-primary" onClick={() => { resetForm(); setShowModal(true); }}>
                  <i className="bi bi-person-plus-fill"></i> Ongeraho
                </button>
                <button className="el-btn el-btn-ghost" onClick={loadData}>
                  <i className="bi bi-arrow-clockwise"></i> Ongera
                </button>
                <button className="el-btn el-btn-green" onClick={exportCSV}>
                  <i className="bi bi-download"></i> Export Excel
                </button>
              </div>

              {/* Alert */}
              {alert && (
                <div className={`el-alert el-alert-${alert.variant}`}>
                  <div className="el-alert-icon" style={{
                    background: alert.variant === "ok" ? "rgba(22,163,74,0.1)" :
                      alert.variant === "err" ? "rgba(220,38,38,0.1)" :
                      alert.variant === "warn" ? "rgba(217,119,6,0.1)" : "rgba(11,61,145,0.1)"
                  }}>
                    <i className={`bi bi-${
                      alert.variant === "ok" ? "check-lg" : alert.variant === "err" ? "x-lg" :
                      alert.variant === "warn" ? "exclamation-lg" : "info-lg"
                    }`}></i>
                  </div>
                  {alert.message}
                  <button className="el-alert-x" onClick={() => setAlert(null)}>✕</button>
                </div>
              )}

              {/* Stats Main */}
              <div className="el-stats-main">
                <div className="el-stat purple">
                  <div className="el-stat-icon" style={{ background: "rgba(11,61,145,0.1)", color: "#0B3D91" }}>
                    <i className="bi bi-people-fill"></i>
                  </div>
                  <div className="el-stat-val">{stats.total}</div>
                  <div className="el-stat-lbl">Bose Hamwe</div>
                  <div className="el-stat-sub">{stats.male} Gabo · {stats.female} Gore</div>
                </div>
                <div className="el-stat red">
                  <div className="el-stat-icon" style={{ background: "rgba(220,38,38,0.08)", color: "#dc2626" }}>
                    <i className="bi bi-exclamation-triangle-fill"></i>
                  </div>
                  <div className="el-stat-val">{stats.needHelp}</div>
                  <div className="el-stat-lbl">Bakenera Ubufasha</div>
                  <div className="el-progress">
                    <div className="el-progress-bar" style={{ width: `${stats.total ? (stats.needHelp / stats.total * 100) : 0}%`, background: "linear-gradient(90deg,#dc2626,#dc2626)" }}></div>
                  </div>
                </div>
                <div className="el-stat green">
                  <div className="el-stat-icon" style={{ background: "rgba(22,163,74,0.1)", color: "#16a34a" }}>
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div className="el-stat-val">{stats.noNeedHelp}</div>
                  <div className="el-stat-lbl">Ntibakeneye</div>
                  <div className="el-progress">
                    <div className="el-progress-bar" style={{ width: `${stats.total ? (stats.noNeedHelp / stats.total * 100) : 0}%`, background: "linear-gradient(90deg,#16a34a,#16a34a)" }}></div>
                  </div>
                </div>
                <div className="el-stat blue">
                  <div className="el-stat-icon" style={{ background: "rgba(11,61,145,0.1)", color: "#0369a1" }}>
                    <i className="bi bi-calendar-heart"></i>
                  </div>
                  <div className="el-stat-val">{stats.avgAge}</div>
                  <div className="el-stat-lbl">Ikigereranyo cy'Imyaka</div>
                </div>
              </div>

              {/* Stats Age */}
              <div className="el-stats-age">
                <div className="el-stat amber">
                  <div className="el-stat-icon" style={{ background: "rgba(217,119,6,0.1)", color: "#d97706" }}>
                    <i className="bi bi-person-fill"></i>
                  </div>
                  <div className="el-stat-val">{stats.elderly}</div>
                  <div className="el-stat-lbl">60–79 imyaka</div>
                </div>
                <div className="el-stat rose">
                  <div className="el-stat-icon" style={{ background: "rgba(220,38,38,0.08)", color: "#dc2626" }}>
                    <i className="bi bi-person-walking"></i>
                  </div>
                  <div className="el-stat-val">{stats.veryElderly}</div>
                  <div className="el-stat-lbl">80+ imyaka</div>
                </div>
              </div>

              {/* Filters */}
              <div className="el-filters">
                <div className="el-search-wrap">
                  <i className="bi bi-search el-search-icon"></i>
                  <input className="el-search" placeholder="Shakisha amazina, telefoni, aderesi..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                </div>
                <DropFilter icon="gender-ambiguous" label="Igitsina" value={filterGender} onChange={setFilterGender}
                  options={[{ v: "all", l: "Byose" }, { v: "Gabo", l: "Gabo" }, { v: "Gore", l: "Gore" }]} />
                <DropFilter icon="hand-thumbs-up" label="Ubufasha" value={filterHelp} onChange={setFilterHelp}
                  options={[{ v: "all", l: "Byose" }, { v: "Yego", l: "Bakenera" }, { v: "Oya", l: "Ntibakeneye" }]} />
                <DropFilter icon="calendar-range" label="Imyaka" value={filterAge} onChange={setFilterAge}
                  options={[{ v: "all", l: "Byose" }, { v: "60-79", l: "60–79" }, { v: "80+", l: "80+" }]} />
              </div>

              {/* Data Panel */}
              <div className="el-glass" style={{ animation: "elScale 0.35s ease" }}>
                <div className="el-glass-body">
                  {loading ? (
                    <div className="el-loader"><span></span><span></span><span></span></div>
                  ) : pageItems.length === 0 ? (
                    <div className="el-empty">
                      <div className="el-empty-icon"><i className="bi bi-people"></i></div>
                      <h5 style={{ color: "rgba(11,61,145,0.6)", fontWeight: 700, marginBottom: 4 }}>Nta makuru ahari</h5>
                      <p style={{ color: "rgba(11,61,145,0.42)", fontSize: "0.82rem" }}>
                        {searchTerm || filterGender !== "all" || filterHelp !== "all" || filterAge !== "all"
                          ? "Hindura ibisuzuma" : "Tangira wongeraho amakuru"}
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Desktop Table */}
                      <div className="el-desktop-tbl">
                        <div className="el-table-wrap">
                          <div className="el-table-scroll">
                            <table className="el-tbl">
                              <thead>
                                <tr>
                                  <th style={{ paddingLeft: 18 }}>#</th>
                                  <th style={{ textAlign: "center", minWidth: 90 }}>Photos</th>
                                  <th>Amazina</th>
                                  <th style={{ textAlign: "center" }}>Imyaka</th>
                                  <th style={{ textAlign: "center" }}>Igitsina</th>
                                  <th>Telefoni</th>
                                  <th>Aderesi</th>
                                  <th style={{ textAlign: "center" }}>Ubufasha</th>
                                  <th style={{ textAlign: "center" }}>Ibikorwa</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pageItems.map((item, idx) => (
                                  <tr key={item.id} style={{ animation: `elSlide 0.3s ease ${idx * 0.035}s both` }}>
                                    <td style={{ paddingLeft: 18, color: "rgba(11,61,145,0.35)", fontWeight: 600 }}>{firstIdx + idx + 1}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {getPhotoUrl(item.ifoto) ? (
                                        <img
                                          src={getPhotoUrl(item.ifoto)}
                                          alt={item.amazina}
                                          onError={handleImgError}
                                          style={{ width: 56, height: 56, borderRadius: 12, objectFit: "cover", border: "2px solid rgba(11,61,145,0.18)", display: "block", margin: "0 auto" }}
                                        />
                                      ) : (
                                        <span style={{ color: "rgba(11,61,145,0.55)", fontSize: "0.78rem", fontWeight: 600 }}>
                                          No Photo
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: 700, color: "#0d1b2a" }}>{item.amazina}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`el-tag ${getAgeTag(item.imyaka)}`}>{item.imyaka}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`el-tag ${item.igitsina === "Gabo" ? "el-tag-blue" : "el-tag-rose"}`}>{item.igitsina}</span>
                                    </td>
                                    <td>
                                      {item.nimero_ya_telephone
                                        ? <span className="el-tag el-tag-green">{item.nimero_ya_telephone}</span>
                                        : <span style={{ color: "rgba(11,61,145,0.3)" }}>—</span>}
                                    </td>
                                    <td>{item.aderesi || <span style={{ color: "rgba(11,61,145,0.3)" }}>—</span>}</td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className={`el-tag ${item.ukeneye_ubufasha === "Yego" ? "el-tag-red" : "el-tag-green"}`}>
                                        {item.ukeneye_ubufasha === "Yego" ? "Yego" : "Oya"}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="el-act-grp">
                                        <button className="el-act view" title="Reba" onClick={() => { setSelectedPerson(item); setShowDetail(true); }}>
                                          <i className="bi bi-eye"></i>
                                        </button>
                                        <button className="el-act edit" title="Hindura" onClick={() => handleEdit(item)}>
                                          <i className="bi bi-pencil"></i>
                                        </button>
                                        <button className="el-act del" title="Siba" onClick={() => handleDelete(item.id)}>
                                          <i className="bi bi-trash3"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Mobile Cards */}
                      <div className="el-cards">
                        {pageItems.map((item, idx) => {
                          const isExp = expandedCard === item.id;
                          return (
                            <div key={item.id} className="el-card" style={{ animationDelay: `${idx * 0.035}s` }}
                              onClick={() => setExpandedCard(isExp ? null : item.id)}>
                              <div className="el-card-head">
                                <div style={{ display: "flex", gap: 10, alignItems: "flex-start", minWidth: 0 }}>
                                  {getPhotoUrl(item.ifoto) ? (
                                    <img
                                      src={getPhotoUrl(item.ifoto)}
                                      alt={item.amazina}
                                      onError={handleImgError}
                                      style={{ width: 46, height: 46, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(11,61,145,0.18)", flexShrink: 0 }}
                                    />
                                  ) : (
                                    <div style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(11,61,145,0.08)", border: "1px solid rgba(11,61,145,0.14)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0B3D91", flexShrink: 0 }}>
                                      <i className="bi bi-person-walking"></i>
                                    </div>
                                  )}
                                  <div>
                                    <div className="el-card-name">{item.amazina}</div>
                                    <div className="el-card-tags">
                                      <span className={`el-tag ${item.igitsina === "Gabo" ? "el-tag-blue" : "el-tag-rose"}`}>{item.igitsina}</span>
                                      <span className={`el-tag ${getAgeTag(item.imyaka)}`}>{item.imyaka} imyaka</span>
                                    </div>
                                  </div>
                                </div>
                                <span className={`el-tag ${item.ukeneye_ubufasha === "Yego" ? "el-tag-red" : "el-tag-green"}`}>
                                  {item.ukeneye_ubufasha === "Yego" ? "Acyenera" : "Ntacyenera"}
                                </span>
                              </div>
                              <div className="el-card-row">
                                <span className="el-card-lbl">Telefoni</span>
                                <span className="el-card-val">{item.nimero_ya_telephone || "—"}</span>
                              </div>
                              <div className="el-card-row">
                                <span className="el-card-lbl">Aderesi</span>
                                <span className="el-card-val">{item.aderesi || "—"}</span>
                              </div>
                              {isExp && (
                                <div style={{ animation: "elUp 0.25s ease" }}>
                                  <div className="el-card-actions" onClick={e => e.stopPropagation()}>
                                    <button className="el-act view" onClick={() => { setSelectedPerson(item); setShowDetail(true); }}>
                                      <i className="bi bi-eye"></i>
                                    </button>
                                    <button className="el-act edit" onClick={() => handleEdit(item)}>
                                      <i className="bi bi-pencil"></i>
                                    </button>
                                    <button className="el-act del" onClick={() => handleDelete(item.id)}>
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </div>
                                </div>
                              )}
                              <div className="el-card-expand">
                                <i className={`bi bi-chevron-${isExp ? "up" : "down"}`}></i>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {renderPagination()}
                    </>
                  )}
                </div>
              </div>

              {/* Add/Edit Modal */}
              {showModal && (
                <div className="el-overlay" onClick={() => setShowModal(false)}>
                  <div className="el-modal" style={{ maxWidth: 720, width: "min(92vw, 720px)" }} onClick={e => e.stopPropagation()}>
                    <div className="el-modal-head">
                      <div className="el-modal-title">
                        <i className={`bi bi-${editId ? "pencil-square" : "person-plus-fill"}`} style={{ color: "#0B3D91" }}></i>
                        {editId ? "Hindura Amakuru" : "Ongeraho Uwo mu Izabukuru"}
                      </div>
                      <button className="el-modal-x" onClick={() => setShowModal(false)}>✕</button>
                    </div>
                    <div className="el-modal-body">
                      <div className="el-form-grid">
                        <div className="el-field">
                          <label className="el-label">Amazina<span className="el-req">*</span></label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-person el-inp-icon"></i>
                            <input className={`el-inp${formErrors.amazina ? " err" : ""}`} name="amazina" value={form.amazina} onChange={handleChange} placeholder="Amazina yombi" />
                          </div>
                          {formErrors.amazina && <div className="el-err-msg">{formErrors.amazina}</div>}
                        </div>
                        <div className="el-field">
                          <label className="el-label">Imyaka<span className="el-req">*</span></label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-calendar3 el-inp-icon"></i>
                            <input className={`el-inp${formErrors.imyaka ? " err" : ""}`} type="number" name="imyaka" value={form.imyaka} onChange={handleChange} placeholder="60+" min="60" />
                          </div>
                          {formErrors.imyaka && <div className="el-err-msg">{formErrors.imyaka}</div>}
                        </div>
                        <div className="el-field">
                          <label className="el-label">Igitsina<span className="el-req">*</span></label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-gender-ambiguous el-inp-icon"></i>
                            <select className="el-sel" name="igitsina" value={form.igitsina} onChange={handleChange}>
                              <option value="Gabo">Gabo</option>
                              <option value="Gore">Gore</option>
                            </select>
                          </div>
                        </div>
                        <div className="el-field">
                          <label className="el-label">Ukeneye Ubufasha</label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-heart-pulse el-inp-icon"></i>
                            <select className="el-sel" name="ukeneye_ubufasha" value={form.ukeneye_ubufasha} onChange={handleChange}>
                              <option value="Oya">Oya — Ntacyenera</option>
                              <option value="Yego">Yego — Acyenera</option>
                            </select>
                          </div>
                        </div>
                        <div className="el-field">
                          <label className="el-label">Telefoni</label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-telephone el-inp-icon"></i>
                            <input className={`el-inp${formErrors.nimero_ya_telephone ? " err" : ""}`} name="nimero_ya_telephone" value={form.nimero_ya_telephone} onChange={handleChange} placeholder="078XXXXXXX" maxLength={10} />
                          </div>
                          {formErrors.nimero_ya_telephone && <div className="el-err-msg">{formErrors.nimero_ya_telephone}</div>}
                        </div>
                        <div className="el-field">
                          <label className="el-label">Aderesi</label>
                          <div className="el-inp-wrap">
                            <i className="bi bi-geo-alt el-inp-icon"></i>
                            <input className="el-inp" name="aderesi" value={form.aderesi} onChange={handleChange} placeholder="Aho atuye" />
                          </div>
                        </div>
                        <div className="el-field el-form-full">
                          <label className="el-label">Ifoto</label>
                          <input
                            className={`el-inp${formErrors.ifoto ? " err" : ""}`}
                            style={{ paddingLeft: 12 }}
                            type="file"
                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                            onChange={handleFileChange}
                          />
                          {formErrors.ifoto && <div className="el-err-msg">{formErrors.ifoto}</div>}
                          {(selectedFile?.name || form.ifoto) && (
                            <div style={{ fontSize: "0.72rem", color: "rgba(11,61,145,0.55)", marginTop: 6 }}>
                              {selectedFile ? "Ifoto yatoranijwe" : "Ifoto iriho"}: {selectedFile?.name || form.ifoto}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="el-modal-foot">
                      <button className="el-btn el-btn-ghost" onClick={() => setShowModal(false)}>Funga</button>
                      <button className="el-btn el-btn-primary" onClick={handleSave}>
                        <i className={`bi bi-${editId ? "check-lg" : "plus-lg"}`}></i>
                        {editId ? "Hindura" : "Bika Amakuru"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Detail Modal */}
              {showDetail && selectedPerson && (
                <div className="el-overlay" onClick={() => setShowDetail(false)}>
                  <div className="el-modal" onClick={e => e.stopPropagation()}>
                    <div className="el-modal-head">
                      <div className="el-modal-title">
                        <i className="bi bi-person-badge" style={{ color: "#0369a1" }}></i>
                        Amakuru Arambuye
                      </div>
                      <button className="el-modal-x" onClick={() => setShowDetail(false)}>✕</button>
                    </div>
                    <div className="el-modal-body">
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                        gap: 20,
                        alignItems: "center",
                        textAlign: "center",
                        marginBottom: 22,
                      }}>
                        <div className="el-detail-avatar" style={{
                          overflow: "hidden",
                          padding: 0,
                          width: "min(100%, 220px)",
                          height: 220,
                          borderRadius: 24,
                          margin: "0 auto",
                          boxShadow: "0 24px 48px rgba(11,61,145,0.45)",
                        }}>
                          {getPhotoUrl(selectedPerson.ifoto) ? (
                            <img
                              src={getPhotoUrl(selectedPerson.ifoto)}
                              alt={selectedPerson.amazina}
                              onError={handleImgError}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <div style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 8,
                              padding: "0 16px",
                              textAlign: "center",
                            }}>
                              <i className="bi bi-person-walking" style={{ fontSize: "2.8rem" }}></i>
                              <span style={{ color: "rgba(11,61,145,0.72)", fontSize: "0.82rem", fontWeight: 600 }}>
                                No Photo Available
                              </span>
                            </div>
                          )}
                        </div>
                        <div>
                          <div style={{
                            fontSize: "0.74rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.14em",
                            color: "rgba(11,61,145,0.55)",
                            marginBottom: 10,
                          }}>
                            Ifoto y'umwirondoro
                          </div>
                          <h3 style={{ fontWeight: 800, color: "#0d1b2a", fontSize: "1.5rem", marginBottom: 8 }}>{selectedPerson.amazina}</h3>
                          <p style={{ color: "rgba(11,61,145,0.65)", fontSize: "0.88rem", marginBottom: 12 }}>
                            Iyi foto nini ifasha kumenya neza uwo muntu muri Amakuru Arambuye.
                          </p>
                          <div style={{ display: "flex", gap: 6, justifyContent: "center", flexWrap: "wrap" }}>
                            <span className={`el-tag ${selectedPerson.igitsina === "Gabo" ? "el-tag-blue" : "el-tag-rose"}`}>{selectedPerson.igitsina}</span>
                            <span className={`el-tag ${getAgeTag(selectedPerson.imyaka)}`}>{selectedPerson.imyaka} imyaka</span>
                            <span className={`el-tag ${selectedPerson.ukeneye_ubufasha === "Yego" ? "el-tag-red" : "el-tag-green"}`}>
                              {selectedPerson.ukeneye_ubufasha === "Yego" ? "Acyenera ubufasha" : "Ntacyenera"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="el-detail-grid">
                        {[
                          { l: "Amazina", v: selectedPerson.amazina, i: "person" },
                          { l: "Imyaka", v: `${selectedPerson.imyaka} imyaka`, i: "calendar3" },
                          { l: "Igitsina", v: selectedPerson.igitsina, i: "gender-ambiguous" },
                          { l: "Telefoni", v: selectedPerson.nimero_ya_telephone || "—", i: "telephone" },
                          { l: "Aderesi", v: selectedPerson.aderesi || "—", i: "geo-alt" },
                          { l: "Ubufasha", v: selectedPerson.ukeneye_ubufasha === "Yego" ? "Yego — Acyenera ubufasha" : "Oya — Ntacyenera", i: "heart-pulse" },
                        ].map((d, i) => (
                          <div key={i} className="el-detail-item">
                            <div className="el-detail-lbl">
                              <i className={`bi bi-${d.i}`} style={{ marginRight: 4 }}></i>{d.l}
                            </div>
                            <div className="el-detail-val">{d.v}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="el-modal-foot">
                      <button className="el-btn el-btn-ghost" onClick={() => setShowDetail(false)}>Funga</button>
                      <button className="el-btn el-btn-primary" onClick={() => { setShowDetail(false); handleEdit(selectedPerson); }}>
                        <i className="bi bi-pencil"></i> Hindura
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="el-footer">
                <i className="bi bi-shield-lock-fill" style={{ marginRight: 5 }}></i>
                Amakuru yose arindwa — akoreshwa ku buryo bw'amategeko
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AbashesheAkanguhe;